import { apiClient } from './api';
import { ApiError } from '../types/api';
import { Geofence } from '../types/geofence';

export const geofenceService = {
  /**
   * The geofence assigned to a drone, or null when it has none.
   *
   * A drone without a fence is the ordinary case, and the backend says so with
   * a 404 — translated to null here so callers don't have to treat "unfenced"
   * as an error. Anything else still throws.
   */
  async getDroneGeofence(droneId: string): Promise<Geofence | null> {
    try {
      return await apiClient.get<Geofence>(
        `/api/v1/drones/${droneId}/geofence`
      );
    } catch (error) {
      if ((error as ApiError)?.status === 404) {
        return null;
      }
      console.error(`Failed to fetch geofence for drone ${droneId}:`, error);
      throw error;
    }
  },
};
